export class AvgAggregator {
    constructor(field) {
        this._nonNullCount = 0;
        this._sum = 0;
        this._type = 'avg';
        this._field = field;
    }
    get field() {
        return this._field;
    }
    get type() {
        return this._type;
    }
    init() {
        this._nonNullCount = 0;
        this._sum = 0;
    }
    accumulate(item) {
        const val = (item && item.hasOwnProperty(this._field)) ? item[this._field] : null;
        if (val !== null && val !== '' && !isNaN(val)) {
            this._nonNullCount++;
            this._sum += parseFloat(val);
        }
    }
    storeResult(groupTotals) {
        if (!groupTotals || groupTotals[this._type] === undefined) {
            groupTotals[this._type] = {};
        }
        if (this._nonNullCount !== 0) {
            groupTotals[this._type][this._field] = this._sum / this._nonNullCount;
        }
    }
}
//# sourceMappingURL=avgAggregator.js.map